export default function CubeDashIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <linearGradient id="cube-dash-bg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#4B2BD6" />
          <stop offset="1" stopColor="#1E1060" />
        </linearGradient>
        <linearGradient id="cube-dash-body" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#FF9E7A" />
          <stop offset="1" stopColor="#F2546B" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="12" fill="url(#cube-dash-bg)" />
      <rect x="0" y="48" width="64" height="16" fill="#140A40" />
      <path d="M0 48h64" stroke="#B7A8FF" strokeWidth="2.5" />
      <path d="M38 48l7-13 7 13z" fill="#10101c" stroke="#EDEBFF" strokeWidth="2" strokeLinejoin="round" />
      <path d="M50 48l7-13 7 13z" fill="#10101c" stroke="#EDEBFF" strokeWidth="2" strokeLinejoin="round" />
      <g transform="rotate(-18 22 26)">
        <rect x="9" y="13" width="26" height="26" rx="5" fill="url(#cube-dash-body)" stroke="#1a1a2e" strokeWidth="2.5" />
        <rect x="12" y="19" width="20" height="8" rx="4" fill="#1a1a2e" />
        <circle cx="17.5" cy="23" r="2.3" fill="#E8FFFB" />
        <circle cx="26.5" cy="23" r="2.3" fill="#E8FFFB" />
        <path d="M18 31q4 3 8 0" fill="none" stroke="#1a1a2e" strokeWidth="2" strokeLinecap="round" />
      </g>
      <path d="M2 22h4M0 38h5" stroke="#FF9E7A" strokeWidth="2.5" strokeLinecap="round" opacity=".7" />
    </svg>
  );
}
